import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import Buffering from '../components/Buffering';


import ListProcesses from '../components/ListProcesses';

import dsd from "../classes/clsDSD";
import {HowToText, getQueryStringParams} from '../utils/utils';

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Processes extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            MyFilters:{
                scope:'my',
                status: ''
            },
            PublishedFilters:{
                scope:'published'
            },
            countMy:null,
            countPublished:null,
            toggle: 0
        };

        this.dsd = new dsd(this);

        this.handleButton = this.handleButton.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.loadedMy = this.loadedMy.bind(this);
        this.loadedPublished = this.loadedPublished.bind(this);

        this.handleMyFilters = this.handleFilters.bind(this,'MyFilters');
        this.handlePublishedFilters = this.handleFilters.bind(this,'PublishedFilters');

    }

    componentDidMount(){

        this.setup();
    
    }


    componentDidUpdate(prevProps, prevState){

        if (prevProps != this.props){
            this.setup();
        }

    }
    
    setup(){


        this.setLayoutContent();

        let StateChange = {
            countMy:null,
            countPublished:null,
            isLoaded: true
        };

        this.setState(StateChange);

        return;

    }

    handleButton(event) {

        switch (event.target.name){
            case 'btnAdd':
                this.props.navigation(`/process?mode=new`);
                break;
            default:
                break;          
        };

        event.preventDefault();
      }

      handleFilters(StateVarName, event) {

        if (this.idFilterTimeout) {
            clearTimeout(this.idFilterTimeout);
        }

        let Filters = {};
        if (this.state[StateVarName]){
            Filters = this.state[StateVarName];
        }

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        Filters[FormFieldName] = FormFieldValue;

        switch (FormFieldName){
            case 'search':
                this.idFilterTimeout = setTimeout(this.setFilters, 500, StateVarName, Filters);
                return;
        }

        this.setFilters(StateVarName, Filters);

        return;

    };

    setFilters(StateVarName, Filters){

        var obj  = {}
        obj[StateVarName] = Filters
        if (StateVarName === 'MyFilters') obj.countMy = null;
        if (StateVarName === 'PublishedFilters') obj.countPublished = null;
        this.setState(obj);
        this.setState({"toggle":!this.state.toggle})

        return;

    };



    about(){

        return(
                <div>                    

                    <div>
                        {this.dsd.model.process && this.dsd.model.process.about &&
                            <PD.MdPresent>
                                {this.dsd.model.process.about}
                            </PD.MdPresent>
                        }                                                
                    </div>

                </div>
            )

        return <div/>

    }


    setLayoutContent(){

        if (this.context.hasLayout){
            
            let Content = {Index:{}};

            this.context.Layout.setLayoutContent(Content)

            localStorage.setItem("dsdContent",JSON.stringify(Content));
            
        }

        return;

    }

    loadedMy(count){

        let StateChange = {};

        StateChange.countMy = 0;
        if (count){
            StateChange.countMy = count;
        }

        this.setState(StateChange);

    }

    loadedPublished(count){

        let StateChange = {};

        StateChange.countPublished = 0;
        if (count){
            StateChange.countPublished = count;
        }

        this.setState(StateChange);

    }


    render() {

        if (!this.dsd || !this.dsd.config || !this.dsd.model || !this.state.isLoaded) {
            return <div><Buffering/></div>
        }

        return (

            <div>
                <PD.Heading>Processes</PD.Heading>

                <PD.Tabs>

                    <div label="About">                    
                        {this.about()}
                    </div>

                    {this.dsd.loggedon &&
                        <div label={<span>My Processes({this.state.countMy === null ? <Buffering/> : this.state.countMy})</span>} data-forcerender="true">
                            <div style={{display:"flex"}}>
                                <PD.Button value='add a new Process' name='btnAdd' onClick={this.handleButton}/>
                                <fieldset style={{display:"flex"}}>
                                    <legend>filters</legend>

                                    <PD.Radio label='Scope' name='scope'  onChange={this.handleMyFilters} value={this.state.MyFilters.scope}>
                                        <label>my</label>
                                        <label>my deprecated</label>
                                    </PD.Radio>
                                                                        
                                    <PD.Select label='Status' name='status'                                                                         
                                        onChange={this.handleMyFilters} 
                                        value={this.state.MyFilters.status}
                                    >                                        

                                        {
                                            this.dsd.config.ComponentStatuses.map(
                                                (status, posStatus) => 
                                                {
                                                    switch (status){
                                                        case 'deprecated':
                                                            return null;
                                                        default:
                                                            return(
                                                                <option key={posStatus} value={status}>{status}</option>
                                                            )
                                                    }
                                                }
                                            )
                                        }
                                    </PD.Select>

                                    <PD.Input label="Search" width="15" name="search" value={this.state.MyFilters.search} onChange={this.handleMyFilters}/>

                                </fieldset>
                            </div>

                            <ListProcesses filters={this.state.MyFilters} columns={{status:true}} toggle={this.state.toggle} onLoad={this.loadedMy}/> 

                        </div>
                    }


                    <div label={<span>Published Processes({this.state.countPublished === null ? <Buffering/> : this.state.countPublished})</span>} data-forcerender="true">
                        <div style={{display:"flex"}}>
                            <fieldset style={{display:"flex"}}>
                                <legend>filters</legend>
                                <PD.Input label="Search" width="15" name="search" value={this.state.PublishedFilters.search} onChange={this.handlePublishedFilters}/>
                            </fieldset>
                        </div>

                        <ListProcesses filters={this.state.PublishedFilters} columns={{owner:true}} toggle={this.state.toggle} onLoad={this.loadedPublished}/>

                    </div>

                </PD.Tabs>
            </div>

            )
        };
};

// Wrap and export
export default function Processes_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();

    return <Processes {...props} navigation={navigation} location={location} />;
  }
